import { TEMP_CART_UPDATED } from "../Constants";

export default function (state = {}, action) {
    switch (action.type) {
    case TEMP_CART_UPDATED:
        if (action.payload) {
            return { ...state, ...action.payload };
        } else {
            return {};
        }


    default:
        return state;
    }
}